<ng-container *ngIf="!isLoading">
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="form-row">
        <div class="form-group col-4">
          <label
            [class.font-weight-bold]="form.get('color')?.dirty"
            for="color"
          >
            {{
              "headers.account_and_user_management.appearance.color" | translate
            }}
            <span class="text-danger">*</span>
          </label>
          <input
            [ngClass]="{
              'is-invalid': isSubmitted && form.get('color')?.invalid
            }"
            class="form-control form-control-sm"
            formControlName="color"
            id="color"
            type="color"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-12">
          <label [class.font-weight-bold]="form.get('name')?.dirty" for="name">
            {{
              "headers.account_and_user_management.appearance.logo" | translate
            }}
            <span class="text-danger">*</span>
          </label>
          <ng-container *ngIf="items[0].logo">
            <img src="{{ imageUrl }}" class="account-img" />
          </ng-container>
          <input type="file" id="file" (change)="handleFileInput($event)" />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="form-group">
      <div class="col-12 d-flex justify-content-between">
        <button (click)="bsModalRef.hide()" class="btn btn-sm btn-light mr-2">
          <i class="la la-ban"></i>
          {{ "navigations.cancel" | translate }}
        </button>
        <button
          (click)="save()"
          [disabled]="
            (!form.pristine && !form.dirty && isSubmitted) || !form.valid
          "
          class="btn btn-sm btn-success"
        >
          <i *ngIf="!isSubmitted" class="la la-save"></i>
          <i *ngIf="isSubmitted" class="la la-spinner la-spin"></i>
          {{ "navigations.save" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
